import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
export function useSettings() {
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    const preview = new URLSearchParams(window.location.search).get("preview") === "1";
    if (cache && !preview) return;
    api.get(preview ? "/settings?draft=1" : "/settings")
      .then((r) => { if (!preview) cache = r.data; setSettings(r.data); })
      .catch(() => {});
  }, []);
  return settings;
}

export function invalidateSettings() { cache = null; }
